import Swiper from 'swiper';
import type { SwiperOptions } from 'swiper/types';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export interface HomeClustersSwiperWidgetOptions {
  rootSelector?: string;
  swiperOptions?: Partial<SwiperOptions>;
}

const defaultSwiperOptions = {
  modules: [Navigation, Autoplay],
  centeredSlides: false,
  slidesPerView: 4,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  speed: 600,
  loop: true,
  grabCursor: true,
} satisfies Partial<SwiperOptions>;

export class HomeClustersSwiperWidget {
  private readonly root: HTMLElement | null;
  private swiper: Swiper | null = null;
  private readonly extraOptions: Partial<SwiperOptions>;

  constructor(options?: HomeClustersSwiperWidgetOptions) {
    this.root = document.querySelector<HTMLElement>(options?.rootSelector ?? '.home-clusters .swiper-box');
    this.extraOptions = options?.swiperOptions ?? {};
  }

  public init(): void {
    if (!this.root) return;

    const el = this.root.querySelector<HTMLElement>('.swiper');

    if (!el) return;

    this.destroy();

    this.swiper = new Swiper(el, {
      ...defaultSwiperOptions,
      ...this.extraOptions,
      modules: this.extraOptions.modules ?? defaultSwiperOptions.modules,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
    });
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
